module.exports = __webpack_public_path__ + "img/covid19.f3cee0ba.png";